import { createContext } from 'react';
export var ThemeContext = /*#__PURE__*/createContext({
  cssVars: {},
  setStack: function setStack() {
    return void 0;
  }
});
export * from './types';